import React, { useEffect, useState } from "react";

export const TemplateDataCourier = ({ templateSet }) => {
  const [goalTemplatePayload, setGoalTemplatePayload] = useState<string>("");

  useEffect(() => {
    let formattedTemplatePayload = formatPayload(templateSet);
    setGoalTemplatePayload(formattedTemplatePayload);
  }, [templateSet]);

  var noTemplates = escape("no templates");

  const formatPayload = (templateSet) => {
    if (!templateSet) return escape(noTemplates);
    let fts = templateSet.map((set) => {
      let formattedTemplate: string = $.param(set.formatForSave());
      return formattedTemplate;
    });
    let formattedPayload = fts;

    return formattedPayload;
  };

  return (
    <div
      id="goal-template-dataCourier"
      style={{ display: "none" }}
      data-goaltemplatedata={goalTemplatePayload}
    ></div>
  );
};
